
export default {
    name: 'OcSliderButtons',

    props: {
        arrowVisibility: {
            type: Boolean,
            default: false,
        },
        arrowColor: {
            type: String,
            default: 'text-black',
        },
        arrowStyle: {
            type: Object,
            default: () => {},
        },
        disableLeftNav: {
            type: Boolean,
            default: false,
        },
        disableRightNav: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        moveSlide(direction) {
            if (direction === '+') {
                this.$emit('arrowRight')
            } else if (direction === '-') {
                this.$emit('arrowLeft')
            }
        },
    },
}
